import { AutocompleteWithLabel } from '@adotel/components'
import { useQuery } from '@apollo/client'
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core'
import React, { FC, useEffect, useState } from 'react'

import { CHANNELS_QUERY } from '../../graphql/channel'
import {
  getEntityCode,
  getEntityId,
  getEntityName,
  getRoleFromStorage
} from '../../helpers/userData'
import { getTranslate } from '../../localization'
import inventoryPagesRoleManagement from '../../staticRoleManagement/inventoryRoleManagement'
import { Channel } from '../../types/channel'
import { ResetInventoryInput } from '../../types/inventory'
import useStyles from './styles/InventoryBulkUpdate.style'

interface InventoryTypeSelectionProps {
  isChannelSelected: boolean
  setisChannelSelected: React.Dispatch<React.SetStateAction<boolean>>
  input: ResetInventoryInput
  setinput: React.Dispatch<React.SetStateAction<ResetInventoryInput>>
}
const InventoryTypeSelection: FC<InventoryTypeSelectionProps> = ({
  isChannelSelected,
  setisChannelSelected,
  input,
  setinput
}) => {
  const classes = useStyles()
  const { data: channelsData, loading: loadingForChannelsList } = useQuery<{
    channels: Channel[]
  }>(CHANNELS_QUERY)

  const [autoCompleteLabelChannel, setautoCompleteLabelChannel] =
    useState<any>(null)

  useEffect(() => {
    if (!isChannelSelected) {
      setinput({
        ...input,
        channelID: undefined
      })
      setautoCompleteLabelChannel(null)
    }
  }, [isChannelSelected])

  const isChannel = inventoryPagesRoleManagement
    .find((item) => item.route === '/inventory/:page')
    ?.sections?.IS_CHANNEL.rolesListWithWriteAccess?.includes(
      getRoleFromStorage()
    )

  useEffect(() => {
    if (isChannel)
      setautoCompleteLabelChannel({
        label: getEntityName(),
        value: getEntityId(),
        code: getEntityCode()
      })
    setinput({ ...input, channelID: getEntityId() })
  }, [loadingForChannelsList])

  return (
    <div className={classes.inventoryTypeFormContainer}>
      <div className={classes.inventoryTypeSelector}>
        <Typography className={classes.inventoryTypeSelectorLabel}>
          {getTranslate('Inventory Type')}
        </Typography>
        <RadioGroup
          className={classes.inventoryTypeRadioGroup}
          value={isChannelSelected ? 'Channel' : 'CRS'}
          onChange={(event) =>
            setisChannelSelected(event.target.value === 'Channel')
          }>
          <FormControlLabel
            disabled={isChannel}
            value="CRS"
            control={<Radio color="primary" />}
            label={getTranslate('CRS')}
          />
          <FormControlLabel
            disabled={isChannel}
            value="Channel"
            control={<Radio color="primary" />}
            label={getTranslate('Channel')}
          />
        </RadioGroup>
      </div>
      {isChannelSelected && (
        <div className={classes.channelSelector}>
          <AutocompleteWithLabel
            value={autoCompleteLabelChannel}
            disabled={isChannel}
            label={getTranslate('Channel')}
            placeholder={getTranslate('Select Channel')}
            includeInputInList
            onChange={(_, v: any) => {
              if (v) {
                setautoCompleteLabelChannel({
                  value: v.value,
                  label: v.label,
                  code: v.code
                })
                setinput({
                  ...input,
                  channelID: v.value
                })
              } else {
                setinput({
                  ...input,
                  channelID: ''
                })
              }
            }}
            getOptionSelected={(option, value) =>
              option.value === value.value && option.label === value.label
            }
            getOptionLabel={(option) => option.label || ''}
            options={
              channelsData
                ? channelsData?.channels.map((item) => ({
                    label: item.basicDetails.name,
                    value: item.basicDetails.channelID || '',
                    code: item.basicDetails.displayChannelCode
                  }))
                : [{ label: getTranslate('Nothing found'), value: '' }]
            }
            size="small"
            inputSize="small"
            loading={loadingForChannelsList}
            loadingText={getTranslate('Loading') + '...'}
          />
        </div>
      )}
    </div>
  )
}

export default InventoryTypeSelection
